import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import { MEDIUM_LIVED_CACHE } from "@/lib/constants/cache";
import type { PolicyMetaData } from "@/core/types";

import { getPolicyMetadata } from "../queryFunctions/getPolicyMetadata";
import { policyMetadataKeys } from "../keyFactory";

type UsePolicyMetadataProps<TData = PolicyMetaData> = {
  select?: (data: PolicyMetaData) => TData;
};

type PolicyMetadataQueryOptions = UseQueryOptions<
  PolicyMetaData,
  unknown,
  PolicyMetaData,
  typeof policyMetadataKeys.base
>;

export function usePolicyMetadata<TData = PolicyMetaData>({
  select,
}: UsePolicyMetadataProps<TData> = {}) {
  return useQuery({ ...optionFactory(), select });
}

export function optionFactory() {
  return {
    cacheTime: 30 * 60 * 1000, // 30 minutes - keep in cache across navigations
    queryFn: getPolicyMetadata,
    queryKey: policyMetadataKeys.base,
    staleTime: MEDIUM_LIVED_CACHE,
  } satisfies PolicyMetadataQueryOptions;
}
